import React, {useState} from "react";
import {storage} from "../utils/localstorage";
import css from "../css/admin.module.css";
import {Button, Paper, TextField, Typography} from "@mui/material";
import {post} from "./post";
import {AppComponent} from "../App";

export const Auth = ({signInFirebaseUser}) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        AppComponent.SetLoading(true);
        await signInFirebaseUser(username, password);
        const {adminKey} = await post("auth", {username, password});
        storage("adminKey", adminKey);
        document.location = document.location;
    }

    return (
        <div className={css.form}>
            <Paper elevation={3} sx={{p: 4}}>
                <Typography variant={"h5"} sx={{m: 1}} align={"center"}>
                    Admin
                </Typography>
                <form onSubmit={onSubmit} autoComplete="on">
                    <TextField size={"small"} onChange={e => setUsername(e.target.value)} value={username}
                               placeholder={"Username"} id="username" name="username" autoComplete="username"
                               type="text"/>
                    <TextField size={"small"} onChange={e => setPassword(e.target.value)} value={password}
                               placeholder={"Password"} id="password" name="password" autoComplete="current-password"
                               type="password"/>
                    <Button variant={"contained"} type="submit">Login</Button>
                </form>
            </Paper>
        </div>
    )
}
